"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.List = void 0;
var _shared = require("@clayui/shared");
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _excluded = ["activation", "active", "children", "className", "displayType", "justified", "modern", "onActiveChange", "shouldUseActive", "tabsId"];
/**
 * SPDX-FileCopyrightText: © 2022 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var List = exports.List = /*#__PURE__*/_react.default.forwardRef(function List(_ref, ref) {
  var activation = _ref.activation,
    active = _ref.active,
    children = _ref.children,
    className = _ref.className,
    _ref$displayType = _ref.displayType,
    displayType = _ref$displayType === void 0 ? null : _ref$displayType,
    justified = _ref.justified,
    __ = _ref.modern,
    onActiveChange = _ref.onActiveChange,
    _ref$shouldUseActive = _ref.shouldUseActive,
    shouldUseActive = _ref$shouldUseActive === void 0 ? false : _ref$shouldUseActive,
    tabsId = _ref.tabsId,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var tabsRef = (0, _react.useRef)(null);
  var _useNavigation = (0, _shared.useNavigation)({
      activation: activation,
      containerRef: tabsRef,
      orientation: 'horizontal'
    }),
    navigationProps = _useNavigation.navigationProps;
  (0, _react.useImperativeHandle)(ref, function () {
    return tabsRef.current;
  }, [tabsRef]);
  (0, _react.useEffect)(function () {
    // Internal API to maintain compatibility with the old Tabs pattern and to
    // only update the initial state when the component is in
    // uncontrolled mode.
    if (!shouldUseActive) {
      return;
    }
    var childrenArray = _react.default.Children.toArray(children);

    // The `active` API in the new pattern has uncontrolled behavior, working
    // just like defaultActive as in the prop declared in the root component.
    for (var index = 0; index < childrenArray.length; index++) {
      var child = childrenArray[index];
      if (/*#__PURE__*/_react.default.isValidElement(child) && child.props.active) {
        onActiveChange(index);
        break;
      }
    }
  }, []);
  return /*#__PURE__*/_react.default.createElement("ul", _extends({}, otherProps, navigationProps, {
    className: (0, _classnames.default)('nav nav-tabs', {
      'nav-justified': justified
    }, _defineProperty({}, "nav-tabs-".concat(displayType), displayType === 'light'), className),
    ref: tabsRef,
    role: "tablist"
  }), _react.default.Children.map(children, function (child, index) {
    var _child$props$innerPro;
    if (! /*#__PURE__*/_react.default.isValidElement(child)) {
      return child;
    }
    return /*#__PURE__*/_react.default.cloneElement(child, {
      active: !shouldUseActive && child.props.active !== undefined ? child.props.active : active === index,
      innerProps: _objectSpread({
        'aria-controls': tabsId && "".concat(tabsId, "-tabpanel-").concat(index),
        id: tabsId && "".concat(tabsId, "-tab-").concat(index)
      }, (_child$props$innerPro = child.props.innerProps) !== null && _child$props$innerPro !== void 0 ? _child$props$innerPro : {}),
      onClick: function onClick(event) {
        var onClick = child.props.onClick;
        if (onClick) {
          onClick(event);
        } else {
          onActiveChange(index);
        }
      }
    });
  }));
});
List.displayName = 'ClayTabsList';